import { useAuth } from "../components/authProvider";

export const withAuth = (Component) => {
  const Wrapper = (props) => {
    const { setToken } = useAuth();
    
    return (
      <Component
      setToken={setToken}
        {...props}
        />
    );
  };
  
  return Wrapper;
};